import { BlurFade } from "components/design/BlurFade";
import { Button } from "components/DesignSystem/Button/Button";
import { Switch } from "components/DesignSystem/Switch/Switch";
import { CrossedEye } from "components/icons/CrossedEye";
import { useShow } from "hooks/useShow";
import { createContext, ReactNode, useContext } from "react";

const Context = createContext({
  shown: true,
  toggle: () => {},
});

export const HideBalancesAndAmountsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { shown, toggle } = useShow(true);

  return (
    <Context.Provider value={{ shown, toggle }}>{children}</Context.Provider>
  );
};

export const useShowBalancesAndAmounts = () => {
  if (!useContext(Context)) {
    throw new Error(
      "useShowBalancesAndAmounts must be used within a HideBalancesAndAmountsProvider"
    );
  }
  return useContext(Context);
};

export const HideBalancesAndAmounts = () => {
  const { shown, toggle } = useShowBalancesAndAmounts();

  return (
    <Button size="small" onClick={toggle}>
      <div className="t-flex t-gap-1.5 t-items-center">
        <span className="sm:t-hidden">
          <CrossedEye />
        </span>
        <span className="sm:t-hidden">Hide balances & amounts</span>
        <span className="t-hidden sm:t-inline">Hide amounts</span>
        <Switch size="small" checked={!shown} />
      </div>
    </Button>
  );
};

export const HideableAmount = ({ children }: { children: ReactNode }) => {
  const { shown } = useShowBalancesAndAmounts();

  return (
    <BlurFade key={String(shown)} duration={0.2}>
      {shown ? children : "$****"}
    </BlurFade>
  );
};
